import { Route, Routes } from 'react-router-dom';
import { availableGeneralSettingsTabs } from '../../variables/GeneralSettings';
import { GeneralSettingsPage } from './GeneralSettingsPage';

export const GeneralSettingsPageRoot = () => (
  <Routes>
    {availableGeneralSettingsTabs.map((tab) => (
      <Route
        key={tab.kind}
        path={tab.path}
        element={<GeneralSettingsPage tab={tab} />}
      />
    ))}
    <Route
      path='*'
      element={<GeneralSettingsPage tab={availableGeneralSettingsTabs[0]} />}
    />
  </Routes>
);
